import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row
} from 'reactstrap';
import LaddaButton, { ZOOM_OUT } from 'react-ladda';
import { ToastContainer, toast } from 'react-toastify';
import { Form as FinalForm, Field } from 'react-final-form';
import { ContextConsumer } from '../../../Context';
import { Redirect } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import 'ladda/dist/ladda-themeless.min.css';

class Login extends React.PureComponent {
  state = { expLeft: false };
  error = message => {
    return toast.error(message);
  };

  render() {
    return (
      <div className="app flex-row align-items-center">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          style={{
            zIndex: 1999
          }}
        />
        <Container>
          <Row className="justify-content-center">
            <Col md="5">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <ContextConsumer>
                      {({ login, token, loading }) => (
                        <FinalForm
                          onSubmit={login}
                          render={({ handleSubmit, pristine, invalid }) => (
                            <Form onSubmit={handleSubmit}>
                              {token && (
                                <Redirect from="/login" to="/dashboard" />
                              )}
                              <h1>Login</h1>
                              <p className="text-muted">
                                Sign In to your account
                              </p>
                              <InputGroup className="mb-3">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i className="icon-user" />
                                  </InputGroupText>
                                </InputGroupAddon>
                                <Field name="Name">
                                  {({ input }) => (
                                    <Input
                                      {...input}
                                      type="text"
                                      placeholder="Username"
                                      autoComplete="username"
                                    />
                                  )}
                                </Field>
                              </InputGroup>
                              <InputGroup className="mb-4">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i className="icon-lock" />
                                  </InputGroupText>
                                </InputGroupAddon>
                                <Field name="Password">
                                  {({ input }) => (
                                    <Input
                                      {...input}
                                      type="password"
                                      placeholder="Password"
                                      autoComplete="current-password"
                                    />
                                  )}
                                </Field>
                              </InputGroup>
                              <Row>
                                <Col xs="6">
                                  <LaddaButton
                                    disabled={pristine || invalid}
                                    className="btn btn-primary btn-ladda px-4"
                                    loading={loading}
                                    data-color="primary"
                                    data-style={ZOOM_OUT}
                                  >
                                    Login
                                  </LaddaButton>
                                </Col>
                                <Col xs="6" className="text-right">
                                  <Button
                                    color="link"
                                    className="px-0"
                                    type="button"
                                  >
                                    Forgot password?
                                  </Button>
                                </Col>
                              </Row>
                            </Form>
                          )}
                        />
                      )}
                    </ContextConsumer>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Login;
